module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-4x3-mobile@3x.43cc4e2a.png";